import { Injectable } from '@angular/core';
import { AppStore } from '@app/app.store';
import { NgxPermissionsService } from 'ngx-permissions';

@Injectable({
  providedIn: 'root'
})
export class PermissionService {
  constructor(protected appStore: AppStore, protected permissionsService: NgxPermissionsService) {}

  isSuperuser() {
    return this.appStore.state.session.user && this.appStore.state.session.user.superuser;
  }

  /**
   * Check if the option has the rights enabled
   *
   * @param permissions array of permissions or a single permission
   * @return true if the user can use this option
   */
  hasPermission(permissions: string | Array<string>): boolean {
    let hasPermission = true;
    if (permissions && !this.isSuperuser()) {
      if (permissions instanceof Array) {
        permissions.forEach(right => {
          if (!this.permissionsService.getPermission(right)) {
            hasPermission = false;
            return false;
          }
        });
      } else {
        if (!this.permissionsService.getPermission(permissions)) {
          hasPermission = false;
        }
      }
    }
    return hasPermission;
  }
}
